<template lang='pug'>

  form(:action="searchPath", method="get" ref="form")
    .searchbar-wrapper
      .searchbar-backdrop
      .container
        .row
          .col-lg-12
            .searchbar.searchbar-linear
              i.fal.fa-map-marker-alt
              input(type="hidden" name="formatted_address" :value="queryParams.formatted_address")
              input(type="hidden" name="longitude" :value="queryParams.longitude")
              input(type="hidden" name="latitude"  :value="queryParams.latitude")
              autocomplete-geolocation(@address-changed="$refs.form.submit()" :value="queryParams.formatted_address")

              .searchbar-item
                .searchbar-button(@click="show = !show")
                  | {{ $t('components.search_bar.more_options') }}
                  | {{ checkedOptionsCount }}
                .searchbar-menu(v-if="show")
                  .row
                    .col-md-12
                      .searchbar-menu__title
                        | {{ $t('components.search_bar.criterias') }}

                      .checkbox.abc-checkbox--dark.abc-checkbox--sm(v-for="population in $store.state.populations.all")
                        input(:id="'checkbox-' + population.id" type="checkbox" :value="population.id" name="by_population_id[]" v-model="queryParams.by_population_id")
                        label(:for="'checkbox-' + population.id") {{ population.attributes.title }}


                      .searchbar-menu__title
                        | {{ $t('components.search_bar.used_technics') }}
                      .checkbox.abc-checkbox--dark.abc-checkbox--sm
                        input#structural(type="checkbox" value="only_structural" name="by_main_practice[]" v-model="queryParams.by_main_practice")
                        label(for="structural") Techniques ostéopathiques à prédominance structurelles (ostéopathie structurelle ou biomécanique), dans le respect et la non douleur.

                      .checkbox.abc-checkbox--dark.abc-checkbox--sm
                        input#facial(type="checkbox" value="only_facial" name="by_main_practice[]" v-model="queryParams.by_main_practice")
                        label(for="facial") Techniques ostéopathiques à prédominance fasciales (ostéopathie tissulaire ou fasciale)

                      .checkbox.abc-checkbox--dark.abc-checkbox--sm
                        input#structural_and_facial(type="checkbox" value="structural_and_facial" name="by_main_practice[]" v-model="queryParams.by_main_practice")
                        label(for="structural_and_facial") La pratique est aussi bien structurelle, tissulaire, viscérale que cranienne, permettant une prise en charge globale et adaptée au patient et à sa problèmatique.




                  .searchbar-menu__submit
                    button.btn.btn-primary
                      span
                        | {{ $t('components.search_bar.validate_choices') }}

              .searchbar-submit
                button.btn.btn-secondary(type="submit")
                  span
                    | {{ $t('components.search_bar.search') }}
</template>

<script>
  import AutocompleteGeolocation from '@appComponents/AutocompleteGeolocation'
  export default {
    data: function () {
      return {
        show: false
      }
    },
    props: {
      searchPath: String,
      queryParams: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: { AutocompleteGeolocation },
    computed: {

      checkedOptionsCount () {
        var count = (this.queryParams.by_population_id || []).length + (this.queryParams.by_main_practice || []).length
        if (count) {
          return `(${count})`
        }
      }
    },
    created () {
      this.$store.dispatch('getAllPopulations')
    }
  }
</script>
